module.exports = __webpack_public_path__ + "img/9.55dff598.png";